<template>
  <div class="columns is-multiline is-variable is-mobile is-5">
    <div class="column" :class="columnClasses" v-for="result in reviewResults" :key="result.id">
      <review-cell-component
        :label="result.getLabel()"
        :value="result.getValue()">
        <template v-slot:actions>
          <div v-if="result.isNotOK()" class="is-pulled-right review-actions customer">
            <button
              class="button check is-outlined radius-circle"
              :class="[ result.finding.hasAnsweredFinding() ? 'is-info' : 'is-danger' ]"
              @click="$emit('showFinding', result)">
              <span class="icon is-medium">
                <i class="mdi mdi-exclamation"></i>
              </span>
            </button>
          </div>
        </template>
        <template v-slot:dependencies>
          <review-dependency-component
            class="dependencies"
            v-for="(dependency, key) in result.dependencies" :key="key"
            :dependency="dependency">
          </review-dependency-component>
        </template>
      </review-cell-component>
    </div>
  </div>
</template>
<script>
  import ReviewCellComponent from '@/components/layout/custom_grid/ReviewCellComponent.vue'
  import ReviewDependencyComponent from '@/components/layout/custom_grid/ReviewDependencyComponent.vue'

  export default {
    name: 'review-customer-grid-component',
    components: {
      ReviewCellComponent,
      ReviewDependencyComponent
    },
    props: {
      reviewResults: {
        type: Array,
        required: true
      },
      columnClasses: {
        type: String,
        default: 'is-6-mobile is-4-tablet is-3-desktop'
      }
    }
  }
</script>
<style lang="sass" scoped></style>
